import { UseSelector } from 'react-redux';
import { notificationService } from '../../../services/notification-service';

export const GetGoogleGeocode = async (address: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_NATIVE_API_BASE_URL}geocode?address=${encodeURIComponent(address)}`
    );


    if (!response.ok) {
      const errorData = await response.json();
      notificationService.sendNotification('error','Unable to retrieve coordinates for the given address');
      return null;
    }

    const data = await response.json();
    return data.results[0];
  } catch (e: any) {
    console.error('Error fetching coordinates:', e);
    return null;
  }
}

//return all geodata for our database
export const getAddressComponentsFromGeodata = (googleGeoData: any) => {
  if (!googleGeoData || !googleGeoData.address_components) {
    console.error('Invalid geocode data provided to getAddressComponentsFromGeodata');
    return {
      city: '',
      state: '',
      country: '',
      street_name: '',
      street_number: '',
      zip_code: ''
    };
  }

  const addressComponents = googleGeoData.address_components;

  const getComponent = (type: string) => {
    return addressComponents.find((component: any) =>
      component.types.includes(type)
    )?.long_name || '';
  };

  // Try multiple types for city to handle international addresses
  // Priority: locality > sublocality > administrative_area_level_2 > administrative_area_level_3
  const getCity = () => {
    const cityTypes = ['locality', 'sublocality', 'sublocality_level_1', 'administrative_area_level_2', 'administrative_area_level_3'];
    for (const type of cityTypes) {
      const city = getComponent(type);
      if (city) {
        return city;
      }
    }
    return '';
  };

  return {
    city: getCity(),
    state: getComponent('administrative_area_level_1'),
    country: getComponent('country'),
    street_name: getComponent('route'),
    street_number: getComponent('street_number'),
    zip_code: getComponent('postal_code')
  };
};

export const getCoordinatesFromGeodata = (googleGeoData: any) => {
  if (!googleGeoData || !googleGeoData.geometry || !googleGeoData.geometry.location) {
    console.error('Invalid geocode data provided to getCoordinatesFromGeodata');
    return {
      latitude: 0,
      longitude: 0,
    };
  }

  const location = googleGeoData.geometry.location;
  const latitude = typeof location.lat === 'function' ? location.lat() : location.lat;
  const longitude = typeof location.lng === 'function' ? location.lng() : location.lng;
  
  // Validate coordinates
  if (typeof latitude !== 'number' || typeof longitude !== 'number' || 
      isNaN(latitude) || isNaN(longitude) || 
      !isFinite(latitude) || !isFinite(longitude)) {
    console.error('Invalid coordinates extracted from geocode data');
    return {
      latitude: 0,
      longitude: 0,
    };
  }
  
  return {
    latitude,
    longitude,
  };
};

